import React, { useContext } from 'react';
import { Button } from 'antd';

import HolidaysContainer from '@totem/components/holidays/HolidaysContainer';
import HolidaysContext from '@totem/components/holidays/HolidaysContext';
import HolidaysFormModal from '@totem/components/holidays/HolidaysFormModal';
import HolidaysTable from '@totem/components/holidays/HolidaysTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const HolidaysContent = () => {
  const { openCreateModal, saving } = useContext(HolidaysContext);

  return (
    <ContentLayout>
      <IBCard
        isCovered
        title={'Holiday Management'}
        extra={
          <Button type="primary" onClick={openCreateModal} loading={saving}>
            Add Holiday
          </Button>
        }
      >
        <HolidaysTable />
      </IBCard>
      <HolidaysFormModal />
    </ContentLayout>
  );
};

const Holidays = () => (
  <HolidaysContainer>
    <HolidaysContent />
  </HolidaysContainer>
);

export default Holidays;
